"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextRightAlignedOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M3,5H29a1,1,0,0,0,0-2H3A1,1,0,0,0,3,5Z"/><path d="M29,11H10.58a1,1,0,1,0,0,2H29a1,1,0,0,0,0-2Z"/><path d="M29,19H3a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z"/><path d="M29,27H17.08a1,1,0,0,0,0,2H29a1,1,0,0,0,0-2Z"/>';
var TextRightAlignedOutlineSVG = function TextRightAlignedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.TextRightAlignedOutlineSVG = TextRightAlignedOutlineSVG;
TextRightAlignedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(TextRightAlignedOutlineSVG);
exports.default = _default;